import { render, staticRenderFns } from "./uploadTwo.vue?vue&type=template&id=76445246&scoped=true"
import script from "./uploadTwo.vue?vue&type=script&lang=js"
export * from "./uploadTwo.vue?vue&type=script&lang=js"
import style0 from "./uploadTwo.vue?vue&type=style&index=0&id=76445246&prod&lang=scss&scoped=true"
import style1 from "./uploadTwo.vue?vue&type=style&index=1&id=76445246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76445246",
  null
  
)

export default component.exports